var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgECause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 467,
    viewBox: "0 0 465 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M465 467H0V0H465V104.06H232.5C224.1 104.06 219.882 108.296 219.882 116.732C219.882 125.169 224.1 129.405 232.5 129.405H465V220.792H232.5C224.1 220.792 219.882 225.028 219.882 233.465C219.882 241.901 224.1 246.137 232.5 246.137H465V466.965V467Z",
    fill: "#FEFEE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECause);
export default __webpack_public_path__ + "static/media/E-Cause.f49da1c6ebb563c7b316e9bb48fe7592.svg";
export { ForwardRef as ReactComponent };